import HTTP from "@/_helpers/http";
import { REGISTEREDUSER__API } from "@/_helpers/urls";
import { REGISTEREDUSER__MUTATIONS } from "../mutation-types";
import { REGISTEREDUSER__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  dashboardUsers: [],
  dashboardTotalUsers: 0,
  allregistereduserusercsv: [],
  users: [],
  totalPending: 0,
  totalUser: 0,
  docApproved: 0,
  ibApproved: 0,
  isLoading: false,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: "",
    lastPage: ""
  },
  tableOptions: { page: 1, itemsPerPage: 10 }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [REGISTEREDUSER__MUTATIONS.TABLEOPTIONS](state, options){
    state.tableOptions.page = Number(options.page) || 1;
    state.tableOptions.itemsPerPage = Number(options.itemsPerPage) || 10;
  },

  [REGISTEREDUSER__MUTATIONS.REGISTEREDUSER](state, data) {
    state.users = data?.data?.users;
    state.totalPending = data?.data?.totalPending;
    state.totalUser = data?.data?.totalUser;
    state.docApproved = data?.data?.docApproved;
    state.ibApproved = data?.data?.ibApproved;
    state.pagination = data?.data?.pagination;
  },
  [REGISTEREDUSER__MUTATIONS.DASHBOARDREGISTEREDUSERS](state, value) {
    state.dashboardUsers = value?.users;
  },
  [REGISTEREDUSER__MUTATIONS.DASHBOARDTOTALUSERS](state, data) {
    state.dashboardTotalUsers = data?.totalUsers;
  },
   [REGISTEREDUSER__MUTATIONS.ALLREGISTEREDUSERUSER](state, data) {
    state.allregistereduserusercsv = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [REGISTEREDUSER__ACTIONS.REGISTEREDUSER]({ state, commit }, parameter = {}) {
    try {
      commit("SET_LOADING", true);
      const {
        duration,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${REGISTEREDUSER__API.REGISTEREDUSER}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(REGISTEREDUSER__MUTATIONS.REGISTEREDUSER, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.error(error);
    }
  },

  async [REGISTEREDUSER__ACTIONS.DASHBOARDTOTALUSERS](
    { state, commit }) {
    try {
      commit("SET_LOADING", true);
      const response = await HTTP().get(REGISTEREDUSER__API.DASHBOARDTOTALUSERS);

      commit(REGISTEREDUSER__MUTATIONS.DASHBOARDTOTALUSERS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.error(error);
    }
  },

  async [REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS](
    { state, commit }) {
    try {
      commit("SET_LOADING", true);

      const { data } = await HTTP().get(REGISTEREDUSER__API.DASHBOARDREGISTEREDUSERS);

      commit(REGISTEREDUSER__MUTATIONS.DASHBOARDREGISTEREDUSERS, data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.error(error);
    }
  },

  async [REGISTEREDUSER__ACTIONS.ALLREGISTEREDUSERUSER](
    { state, commit }) {
    try {
      commit("SET_LOADING", true);
      const res = await HTTP().get(REGISTEREDUSER__API.ALLREGISTEREDUSERUSER);
      commit(REGISTEREDUSER__MUTATIONS.ALLREGISTEREDUSERUSER, res.data.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.error(error);
    }
  },

  async [REGISTEREDUSER__ACTIONS.UPDATEIBSTATUS](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().post(
        REGISTEREDUSER__API.UPDATEIBSTATUS,
        parameter
      );
      await dispatch(REGISTEREDUSER__ACTIONS.REGISTEREDUSER);
      await dispatch(REGISTEREDUSER__ACTIONS.DASHBOARDREGISTEREDUSERS);
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  },
};

export default {
  strict: process.env.NODE_ENV !== "production",
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
